import axios from '@/lib/axios';
import { FixedAsset, PaymentSchedule, Product, PurchaseOrderMember } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0700. 支払予定編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_schedules/:payment_schedule_id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  payment_schedule_id: number;
  year_month: string;
  monthly_amount?: number;
  spot_amount?: number;
};
const updatePaymentSchedule = (props: Props): Promise<PaymentSchedule> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_schedules/${props.payment_schedule_id}`,
    props
  );
};

export const useUpdatePaymentSchedule = () => {
  return useMutation({
    mutationFn: updatePaymentSchedule,
  });
};
